(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.debt-financing
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]))

(defn debt-financing-section
  [{:keys [description-text debt-key-figures portfolio-debt-financing hedging
           lender-by-loans-outstanding major-tenants nav-breakdown inrev-nav
           limited-partners]}
   props]
  [section
   "Debt financing"
   (str "debt-financing-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [grid/row {}
     [grid/column {:large 6}
      [free-text-card/view "Description" description-text props]]
     [grid/column {:large 6}
      [tabular-card/dynamic-table "Portfolio Debt key figures" debt-key-figures props]]]
    [tabular-card/dynamic-table "Debt financing, €" portfolio-debt-financing props]
    (when (some->> hedging
                   :figures
                   :data
                   (remove nil?)
                   (seq))
      [tabular-card/dynamic-table "Hedging, €" hedging props])
    [chart-card/row-view "Lender by loans outstanding, M€" lender-by-loans-outstanding props]
    [tabular-card/dynamic-table "Major Tenants" major-tenants props] 
    [tabular-card/dynamic-table "NAV breakdown (IFRS), €" nav-breakdown props]
    [tabular-card/dynamic-table "NAV breakdown (INREV), €" inrev-nav props]
    [tabular-card/dynamic-table "Investors, €" limited-partners props]]])
